import { MutationTree } from 'vuex';
import { ITagState } from '@/tags/store/tag.store';
import { ITag } from '@/types/Tag';

export const mutationSetLoading = 'setLoading';
export const mutationSetLoaded = 'setLoaded';
export const mutationSetTags = 'setTags';
export const mutationAddTag = 'addTag';

export const mutations: MutationTree<ITagState> = {
  [mutationSetTags](state: ITagState, tags: ITag[]) {
    state.tags = tags;
  },
  [mutationSetLoaded](state: ITagState, loaded: boolean) {
    state.loaded = loaded;
  },
  [mutationSetLoading](state: ITagState, loading: boolean) {
    state.loading = loading;
  },
  [mutationAddTag](state: ITagState, newTag: ITag) {
    state.tags = [...state.tags, newTag];
  },
};
